import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { Icon } from "@iconify/react";
const LinkOpenTab = ({link}) => {
  return (
    <Box>
    <Button
    
     sx={{
        marginLeft: 2,
        visibility:link?'visible':'hidden'
      }}
      size="small"
      onClick={() =>
        window.open(
          `${link}`,
          "_blank"
        )
      }
      variant="outlined"
    >
      <Icon
        icon="material-symbols:right-click-rounded"
        width="20"
        height="20"
      />
      <Typography variant="button">Link</Typography>
    </Button>
  </Box>
  )
}

export default LinkOpenTab